import React from "react";
import { useRef } from "react";

import Header from "./Header";
import Intro from "./Intro";
import Bar from "./Bar";
import ArtprojectList from "./ArtprojectList";
import About from "./About";
import Footer from "./Footer";

import { HomeContainer } from "../styled-components/homestyle"

const Home = ( {artprojects} ) => {
  const aboutRef = useRef(null);
  const artprojectListRef = useRef(null);

  return (
    <HomeContainer>
      <Bar />
      <Header aboutRef={aboutRef} artprojectListRef={artprojectListRef}/>
      <Intro />
      <ArtprojectList ref={artprojectListRef} artprojects={artprojects} />
      <About ref={aboutRef}/>
      <Footer />
    </HomeContainer>
  )
}

export default Home;